import Api from "../api";

export const fetchUsers = async () => {
    const { data } = await Api.request({
        url: "/retailer/user/users-list",
    });
    return data.users;
};
